import { z as e } from "zod";
const m = e.object({
  number: e.number().describe("The amount of money"),
  formatted: e.string().describe("The formatted amount of money")
});
export {
  m as moneySchema
};
